import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37138cca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "lookup-container"
}
const _hoisted_4 = { class: "telephone-input-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label required-container" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Phone or Mobile Number"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "Required")
], -1))
const _hoisted_6 = { class: "column address-container" }
const _hoisted_7 = { class: "lookup-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Search for an address or enter an address manually", -1))
const _hoisted_9 = { class: "title" }

import { PropType, computed, ref, onMounted, watch, inject } from "vue";
import { LandlordPersonalInfo } from "@/types/switches/LandlordPersonalInfo";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { ContactsValidation } from "acquaint-api/validation/ContactsValidation";
import ScrollView from "@/components/ui/scroll-view.vue";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import AcquaintTextbox from "@/components/ui/inputs/acquaint-textbox.vue";
import SwitchContactLookup from "@/components/ui/lookup/switch-contact-lookup.vue";
import { ContactFindTypeRestriction } from "@/enums/contacts/ContactFindTypeRestriction";
import { Contacts } from "acquaint-api/models/Contacts";
import { mapAcquaintContactToLandlordPersonalInfo } from "@/utils/utility-switching/SwitchContactMapper";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import AutoAddressWrapper from "@/components/ui/address/auto-address-wrapper.vue";
import { Address } from "@/types/generic/Address";
import { VueTelInput } from "vue-tel-input";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";
import { FieldSize } from "@/enums/system/FieldSize";


export default /*#__PURE__*/_defineComponent({
  __name: 'property-owner-details-page',
  props: {
  /**
   * The object containing personal information about the landlord.
   * This typically includes name, contact details, and address.
   * @type {LandlordPersonalInfo}
   * @required
   */
  landlordDetails: {
    type: Object as PropType<LandlordPersonalInfo>,
    required: true,
  },

  /**
   * A boolean indicating whether the provided telephone number is valid.
   * This may be used for form validation or displaying error messages.
   * @type {boolean}
   * @required
   */
  telephoneNumberValid: {
    type: Boolean,
    required: true,
  },

  /**
   * The title displayed for the landlord details section.
   * @type {string}
   * @default ''
   */
  title: {
    type: String,
    default: "",
  },

  /**
   * The validation group name used for form validation.
   * This helps organize validation rules within a specific form section.
   * @type {string}
   * @required
   */
  validationGroup: {
    type: String,
    required: true,
  },

  /**
   * The label to be used when displaying the owner's information.
   * This is useful for customizing how the landlord is referenced in the UI.
   * @type {string}
   * @required
   */
  ownerLabel: {
    type: String,
    required: true,
  },
},
  emits: [
  /**
   * Emits an event to update the landlord's personal details in the parent component.
   * This is typically used in a two-way binding pattern (e.g., with `v-model`).
   */
  "update:landlordDetails",

  /**
   * Emits an event to update the validation status of the telephone number in the parent component.
   * This ensures the parent component is aware of whether the telephone number is valid or not.
   * This is typically used in a two-way binding pattern (e.g., with `v-model`).
   */
  "update:telephoneNumberValid",
],
  setup(__props, { emit }) {

const props = __props;





const landlordPersonalInfo = computed({
  get: () => props.landlordDetails,
  set: (value: LandlordPersonalInfo) => emit("update:landlordDetails", value),
});

const telephoneNumberValid = computed({
  get: () =>
    props.telephoneNumberValid == undefined ||
    props.telephoneNumberValid == false
      ? false
      : true,
  set: (value: Boolean) =>
    emit(
      "update:telephoneNumberValid",
      value == undefined || value == false ? false : true,
    ),
});

const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const screenWidth = ref(screen.width);

const onContactSelected = (e: Contacts) => {
  landlordPersonalInfo.value = mapAcquaintContactToLandlordPersonalInfo(e);
};

const fetchDetailsFillFields = async () => {
  if (landlordPersonalInfo.value.id <= 0) {
    return;
  }

  let selectedPropertyLandlord: Contacts;

  try {
    selectedPropertyLandlord = await apiClient.httpGet<Contacts>(
      `database/contacts/${landlordPersonalInfo.value.id}`,
    );
  } catch (err) {
    return;
  }

  if (selectedPropertyLandlord) {
    landlordPersonalInfo.value = mapAcquaintContactToLandlordPersonalInfo(
      selectedPropertyLandlord,
    );
  }
};

onMounted(() => {
  fetchDetailsFillFields();
});

watch(
  () => landlordPersonalInfo.value.id,
  () => {
    fetchDetailsFillFields();
  },
);

const onAddressFound = (e: Address) => {
  landlordPersonalInfo.value.address = e;
};

const preferredTelehoneNumbers = ["IE", "GB", "FR", "DE", "ES", "PL"];

const telehpneInputOptions = {
  required: true,
};

const phoneNumberValidated = (e: any) => {
  telephoneNumberValid.value = e.valid;
};

const onSearchCompleted = () => {
  resetScroll.value = true;
};

const resetScroll = ref(false);

const showOwnerLookup = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ScrollView, {
    "reset-scroll": resetScroll.value,
    "onUpdate:resetScroll": _cache[10] || (_cache[10] = ($event: any) => ((resetScroll).value = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        class: _normalizeClass(["landlord-details", { smallScreen: screenWidth.value < 875 }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(props.title), 1),
          (showOwnerLookup.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(SwitchContactLookup, {
                  "find-type-restriction": _unref(ContactFindTypeRestriction).PropertyOwners,
                  label: `Look up ${__props.ownerLabel}`,
                  "results-max-width": "50%",
                  onContactSelected: onContactSelected,
                  toolTipTarget: "#landlordSearch",
                  toolTipId: "landlordSearch"
                }, {
                  "tooltip-content": _withCtx(() => [
                    _createTextVNode("Search for an existing contact to pre-fill the information below.")
                  ]),
                  _: 1
                }, 8, ["find-type-restriction", "label"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(LookupSingleSelect, {
            modelValue: landlordPersonalInfo.value.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((landlordPersonalInfo.value.title) = $event)),
            "lookup-source": _unref(LookupTableSource).Titles,
            label: "Title",
            requiredInput: false,
            validationGroup: props.validationGroup,
            "allow-zero-value": true
          }, null, 8, ["modelValue", "lookup-source", "validationGroup"]),
          _createVNode(AcquaintTextbox, {
            modelValue: landlordPersonalInfo.value.firstName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((landlordPersonalInfo.value.firstName) = $event)),
            fieldValidation: _unref(ContactsValidation).FirstNames,
            label: "First Name",
            requiredInput: true,
            validationGroup: props.validationGroup,
            "value-change-event": _unref(TextboxValueChangeEvent).Change
          }, null, 8, ["modelValue", "fieldValidation", "validationGroup", "value-change-event"]),
          _createVNode(AcquaintTextbox, {
            modelValue: landlordPersonalInfo.value.lastName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((landlordPersonalInfo.value.lastName) = $event)),
            fieldValidation: _unref(ContactsValidation).LastName,
            label: "Last Name",
            requiredInput: true,
            validationGroup: props.validationGroup,
            "value-change-event": _unref(TextboxValueChangeEvent).Change
          }, null, 8, ["modelValue", "fieldValidation", "validationGroup", "value-change-event"]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_unref(VueTelInput), {
              defaultCountry: 353,
              inputOptions: telehpneInputOptions,
              modelValue: landlordPersonalInfo.value.number,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((landlordPersonalInfo.value.number) = $event)),
              mode: "international",
              "valid-characters-only": true,
              onValidate: phoneNumberValidated,
              preferredCountries: preferredTelehoneNumbers
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(AutoAddressWrapper, {
              onOnAddressFound: onAddressFound,
              onOnSearchCompleted: onSearchCompleted
            })
          ]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(__props.ownerLabel) + " Address", 1),
          _createVNode(AcquaintTextbox, {
            modelValue: landlordPersonalInfo.value.address.propertyName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((landlordPersonalInfo.value.address.propertyName) = $event)),
            label: "Property Name",
            fieldValidation: _unref(ContactsValidation).HomeProperty,
            validationGroup: props.validationGroup,
            requiredInput: false,
            "value-change-event": _unref(TextboxValueChangeEvent).Change
          }, null, 8, ["modelValue", "fieldValidation", "validationGroup", "value-change-event"]),
          _createVNode(AcquaintTextbox, {
            modelValue: landlordPersonalInfo.value.address.street,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((landlordPersonalInfo.value.address.street) = $event)),
            label: "Street",
            validationGroup: props.validationGroup,
            fieldValidation: _unref(ContactsValidation).HomeStreet,
            requiredInput: false,
            "value-change-event": _unref(TextboxValueChangeEvent).Change,
            width: _unref(FieldSize).Full
          }, null, 8, ["modelValue", "validationGroup", "fieldValidation", "value-change-event", "width"]),
          _createVNode(AcquaintTextbox, {
            modelValue: landlordPersonalInfo.value.address.locality,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((landlordPersonalInfo.value.address.locality) = $event)),
            label: "Locality",
            validationGroup: props.validationGroup,
            fieldValidation: _unref(ContactsValidation).HomeLocality,
            requiredInput: false,
            "value-change-event": _unref(TextboxValueChangeEvent).Change,
            width: _unref(FieldSize).Full
          }, null, 8, ["modelValue", "validationGroup", "fieldValidation", "value-change-event", "width"]),
          _createVNode(AcquaintTextbox, {
            modelValue: landlordPersonalInfo.value.address.town,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((landlordPersonalInfo.value.address.town) = $event)),
            fieldValidation: _unref(ContactsValidation).HomeTown,
            label: "Town",
            validationGroup: props.validationGroup,
            requiredInput: true,
            "value-change-event": _unref(TextboxValueChangeEvent).Change,
            width: _unref(FieldSize).Full
          }, null, 8, ["modelValue", "fieldValidation", "validationGroup", "value-change-event", "width"]),
          _createVNode(AcquaintTextbox, {
            modelValue: landlordPersonalInfo.value.address.region,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((landlordPersonalInfo.value.address.region) = $event)),
            fieldValidation: _unref(ContactsValidation).HomeRegion,
            label: "County",
            validationGroup: props.validationGroup,
            requiredInput: true,
            "value-change-event": _unref(TextboxValueChangeEvent).Change,
            width: _unref(FieldSize).Full
          }, null, 8, ["modelValue", "fieldValidation", "validationGroup", "value-change-event", "width"]),
          _createVNode(AcquaintTextbox, {
            modelValue: landlordPersonalInfo.value.address.postCode,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((landlordPersonalInfo.value.address.postCode) = $event)),
            fieldValidation: _unref(ContactsValidation).HomePostcode,
            label: "Eircode",
            validationGroup: props.validationGroup,
            requiredInput: false,
            "value-change-event": _unref(TextboxValueChangeEvent).Change,
            width: _unref(FieldSize).Full
          }, null, 8, ["modelValue", "fieldValidation", "validationGroup", "value-change-event", "width"])
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["reset-scroll"]))
}
}

})